<input
  [ngClass]="{
    error: hasError()
  }"
  type="text"
  [required]="required()"
  [placeholder]="placeholder()"
  [readOnly]="readonly()"
  [disabled]="disabled()"
  [value]="value() | ftrDate: { format: timeFormat() }"
  (change)="onChange($event)"
  [attr.aria-label]="label()"
  (focus)="handleFocus($event)"
  (blur)="handleBlur($event)"
  #inputElement
/>

@if (hasError()) {
  <ftr-icon [icon]="'Warning'" [align]="'Top'" [size]="'Regular'"></ftr-icon>
}
